const prependZero = (num: number) => (num < 10 ? `0${num}` : num);

// examples: 12/20, 01/09
const getMonthAndDay = (date: Date) => {
  const day = prependZero(date.getDate());
  const month = prependZero(date.getMonth() + 1);

  return `${month}/${day}`;
};

export default getMonthAndDay;
